'use client';

import { c as _c } from "react/compiler-runtime";
import { VariantFieldset } from '../product-details';
import { MiniPdpVariantRow } from './mini-pdp-variant-row';
import { type MiniPdpVariantsProps, useMiniPdpVariants } from './model/use-mini-pdp-variants';
export function MiniPdpVariants(t0) {
  const $ = _c(10);
  const {
    base,
    tailored
  } = t0;
  let t1;
  if ($[0] !== base || $[1] !== tailored) {
    t1 = {
      base,
      tailored
    };
    $[0] = base;
    $[1] = tailored;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    handleVariantChange,
    variantGroups
  } = useMiniPdpVariants(t1);
  if (!variantGroups.length) {
    return null;
  }
  let t2;
  if ($[3] !== handleVariantChange || $[4] !== variantGroups) {
    let t3;
    if ($[6] !== handleVariantChange) {
      t3 = group => <VariantFieldset key={group.name} legendKey={group.name} legendValue={group.display}>{group.variants.length > 1 && <MiniPdpVariantRow group={group} onChange={value => handleVariantChange(group.name, value)} />}</VariantFieldset>;
      $[6] = handleVariantChange;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = variantGroups.map(t3);
    $[3] = handleVariantChange;
    $[4] = variantGroups;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <div className="mini-pdp-drawer__variants" data-testid="mini-pdp-variants">{t2}</div>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}